import { FAuth, FFunctions } from '../firebase/firebase';
import firebase from 'firebase/app';
import { ApplicationsEnum } from '@styreportalen/common';

const auth = FAuth();
const functions = FFunctions();

type UpdateLastLoginRequest = {
    application: ApplicationsEnum;
    org_id?: string;
    signInProvider: string | null;
    first_time_logged_in: boolean;
};

export const updateLastLogin = async (
    authUser: firebase.User,
    orgId?: string,
): Promise<firebase.functions.HttpsCallableResult> => {
    const update: UpdateLastLoginRequest = {
        application: ApplicationsEnum.SENTRALPORTALEN,
        org_id: orgId,
        signInProvider: null,
        first_time_logged_in: false,
    };

    const result = await authUser.getIdTokenResult();
    if (result.signInProvider) {
        update.signInProvider = result.signInProvider;
    }

    if (window.sessionStorage.getItem('SPAuthToken') !== result.token) {
        window.sessionStorage.setItem('SPAuthToken', result.token);
        update.first_time_logged_in = true;
    }

    return functions.httpsCallable('global-users-updateLastLogin')(update);
};

export async function login(email: string, password: string) {
    if (email === '' || password === '') {
        throw new Error('login/invalid-input');
    }

    if (email === 'tokenlogin') {
        return auth.signInWithCustomToken(password);
    } else {
        return auth.signInWithEmailAndPassword(email, password);
    }
}
